import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxFontXl,
  TextBoxMaxLine1Footnote5Secondary,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'
import { TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockTVShowsProps extends Omit<
  ITextBlockProps,
  'children'
> {
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockTVShows = ({
  title,
  description,
  rowGap = TextBlockRowGap.INDENT_0,
  ...rest
}: ITextBlockTVShowsProps): JSX.Element => {
  return (
    <TextBlock rowGap={rowGap} {...rest}>
      <TextBoxMaxLine1Footnote5Secondary title={title} />
      <TextBoxFontXl title={description} />
    </TextBlock>
  )
}
